































































































































































import Vue from "vue";
import { USER_REGISTER } from "@/queries/anonymous/mutation.graphql";
import { mapMutations } from "vuex";
export default Vue.extend({
  data: () => ({
    form: {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      venueType: null,
    },
    isLoading: false,
    showTemsModal: false,
  }),
  methods: {
    register() {
      this.isLoading = true;
      this.$store.commit("loadersModule/toggleGlobalLoader", true);
      this.$apollo
        .mutate({
          mutation: USER_REGISTER,
          variables: {
            ...this.form,
          },
        })
        .then((data: any) => {
          this.isLoading = false;
          this.$store.commit("loadersModule/toggleGlobalLoader", false);
          if (data.data.signup) {
            const userToken = data.data.signup.tokenKey;
            const userId = data.data.signup.userId;
            this.$store.commit("authModule/authenticate", {
              userToken,
              userId,
            });
          }
        })
        .catch((error) => {
          const errors = {
            duplicate:
              'Uniqueness violation. duplicate key value violates unique constraint "User_email_key"',
          };
          this.isLoading = false;
          this.$store.commit("loadersModule/toggleGlobalLoader", false);
          if (error.graphQLErrors[0].message === errors.duplicate) {
            this.$toastr.e("This email is registered before!");
            return;
          }
          this.$toastr.e(error.graphQLErrors[0].message);
        });
    },
  },
});
